/**
 * @generated SignedSource<<5c750e34b44478fa36a08fcff78c31b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeetingCostUnitEnum = "CURRENCY" | "HOURS";
export type MeetingCostEditPanelUseCalculateMeetingCostQuery$variables = {
  userIds: ReadonlyArray<string>;
};
export type MeetingCostEditPanelUseCalculateMeetingCostQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly extensionSettings: {
        readonly meetingCostAvgSalary: number;
        readonly meetingCostEnabled: boolean;
        readonly meetingCostUnit: MeetingCostUnitEnum;
      };
    };
    readonly user: {
      readonly annualizedMeetingCost: number | null;
    };
    readonly usersById: ReadonlyArray<{
      readonly annualizedMeetingCost: number | null;
    }> | null;
  };
};
export type MeetingCostEditPanelUseCalculateMeetingCostQuery = {
  response: MeetingCostEditPanelUseCalculateMeetingCostQuery$data;
  variables: MeetingCostEditPanelUseCalculateMeetingCostQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "annualizedMeetingCost",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostUnit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostAvgSalary",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userIds"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v1/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCostEditPanelUseCalculateMeetingCostQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExtensionSettings",
                "kind": "LinkedField",
                "name": "extensionSettings",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "usersById",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingCostEditPanelUseCalculateMeetingCostQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExtensionSettings",
                "kind": "LinkedField",
                "name": "extensionSettings",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "usersById",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f98068a4bcb4677e03910321b8018287",
    "id": null,
    "metadata": {},
    "name": "MeetingCostEditPanelUseCalculateMeetingCostQuery",
    "operationKind": "query",
    "text": "query MeetingCostEditPanelUseCalculateMeetingCostQuery(\n  $userIds: [ID!]!\n) {\n  viewer {\n    user {\n      annualizedMeetingCost\n      id\n    }\n    account {\n      extensionSettings {\n        meetingCostEnabled\n        meetingCostUnit\n        meetingCostAvgSalary\n        id\n      }\n      id\n    }\n    usersById(userIds: $userIds) {\n      annualizedMeetingCost\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc16200f5a93674ebdf8107cb1052e31";

export default node;
